import api from './utilPartner';

const controller = 'PropostaDadosGarantia';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ListarGarantiasPorProposta: function (dto) {
    return api.Axios.GetParams(url + '/ListarGarantiasPorProposta', dto);
  },
  ListarGarantiaDetalhes: function (dto) {
    return api.Axios.GetParams(url + '/ListarGarantiaDetalhes', dto);
  }
});
